import { createAsyncThunk } from '@reduxjs/toolkit';

import { type FetchUserInfoParams, UserInfoFetcher } from '../../api/fetchers/userInfo/fetcher';

interface FetchUserInfoActionParams extends FetchUserInfoParams {
  essential: boolean;
}

export const fetchUserInfoAction = createAsyncThunk('userInfo/fetchUserInfo', (params: FetchUserInfoActionParams) => {
  return UserInfoFetcher.fetch({
    ...params,
  });
});
